import Cookies from "js-cookie";

const addWorkspaceKnowledge = async ({ commit, rootGetters, dispatch }, payload) => {
    commit("SET_WORKSPACE_KNOWLEDGE_FILES_LOADING", true);
    try {
        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];
        const data = { ...payload, customer_id: customer.customer_id, userId: Cookies.get('userId') };

        if (customer.customer_id === 0) {
            data.customer_id = selected_customer.customer_id;
        }

        let reqURL = `/proxy/ai/workspaces/${data.workspaceId}/knowledge?customer_id=${data.customer_id}&search=${data.search || ''}`;
        if(payload.isExternal) {
            reqURL = `/proxy/ai/workspaces/${data.workspaceId}/knowledge/external?customer_id=${data.customer_id}&search=${data.search || ''}`
        }

        const response = await window.axios.post(reqURL, data);
        if (response && response.data.success) {
            commit('PUSH_WORKSPACE_FILES', response.data.knowledge)
            dispatch("notifications/pushNotification", 'File Added to Knowledge Base', { root: true });
        } else {
            throw response.data;
        }
    } catch (error) {
        dispatch("notifications/setError", error.message, { root: true });
    } finally {
        commit("SET_WORKSPACE_KNOWLEDGE_FILES_LOADING", false);
    }
};

export default addWorkspaceKnowledge;